import { Endpoint } from '../endpoint';

export const ReferenceValueSynonym = new Endpoint('reference_value_synonym');
